import { gql } from '@apollo/client';

export const ALL_ACTIVITY_SESSIONS = gql`
  query AllActivitySessions($input: FilteredAllActivitySession) {
    activitySessions: allActivitySessions(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }

      edges {
        node {
          id
          name
          actualDate
          additionalNotes
          description
          sessionStatus
          numberOfAttendees
          plannedAttendees
          sessionBasedAttendeesCount
          sessionBasedActualAttendeesCount
          totalGroupFormAttendees
          plannedDate
          plannedDuration
          attendeeCount
          activity {
            id
            attendeeCount
            name
            numberOfAttendees
            trackingLevel
            renderGroupForm
            multiDay
            weeklyTracking
            sessionBasedAttendees
            activityTargets {
              id
              cohort {
                id
                name
              }
              institution {
                id
                name
              }
            }
          }
          activityTarget {
            id
            cohort {
              id
              name
            }
            institution {
              id
              name
            }
            expectedNumberOfAttendees
          }
          createdBy {
            id
            firstName
            lastName
          }
          approvedBy {
            id
            firstName
            lastName
          }
          flaggedby {
            id
            firstName
            lastName
          }
          attendeeHeadCount {
            id
            sundayNumberOfAttendees
            mondayNumberOfAttendees
            tuesdayNumberOfAttendees
            wednesdayNumberOfAttendees
            thursdayNumberOfAttendees
            fridayNumberOfAttendees
            saturdayNumberOfAttendees
            sundayNumberOfExpectedAttendees
            mondayNumberOfExpectedAttendees
            tuesdayNumberOfExpectedAttendees
            wednesdayNumberOfExpectedAttendees
            thursdayNumberOfExpectedAttendees
            fridayNumberOfExpectedAttendees
            saturdayNumberOfExpectedAttendees
            numberOfExpectedAttendees
            numberOfAttendees
            stakeHolderGroup {
              id
              name
            }
            targetGroup {
              id
              name
            }
          }
        }
      }
    }
  }
`;
